/**
 * Top-level app sections a scan can originate from.
 * This is an allowlist: a pathname outside these sections reports `unknown` and its path is dropped,
 * this protects against scanning routes carrying secrets.
 */
export const ALLOWED_SCAN_ROUTES = ['analytics', 'hub', 'orders', 'settings', 'shipments'] as const;
export const UNKNOWN_SCAN_ROUTE = 'unknown' as const;
